import UserService from '../services/UserService';
import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from 'react';
import UserManagementService from '../services/UserManagement.service';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ROUTER } from '../constants/router';

export const AuthContext = createContext();

export default function UserProvider({ children }) {
    const navigate = useNavigate();
    const id = UserService.getUi();
    const [username, setUsername] = useState('');
    const [role, setRole] = useState('');
    const [user, setUser] = useState();
    const [debound, setDebound] = useState(true);

    const location = useLocation();

    const getUserDetail = useCallback(async () => {
        setDebound(true);
        try {
            const { data } = await UserManagementService.getUserDetail(id);
            const item = data?.resultData;
            if (item) {
                setUser(item);
                setUsername(`${item.fname} ${item.lname}`);
                setRole(`${item.role}`);
                setDebound(false);
            }
        } catch (error) {
            setDebound(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        if (id) {
            getUserDetail();
            return;
        }
        setDebound(false);
        navigate(ROUTER.USER_NOT_FOUND);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        if (location?.pathname) {
            if (!user && !debound) {
                navigate(ROUTER.USER_NOT_FOUND);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location?.pathname, user]);

    useEffect(() => {
        const endDate = UserService.getEndDate()?.split('/');
        const startDate = UserService.getStartDate()?.split('/');
        const date = new Date(new Date().setHours(0, 0, 0, 0));
        if (endDate && startDate) {
            let expiredDate = new Date(
                +endDate[2],
                endDate[1] - 1,
                +endDate[0]
            );
            let effectiveDate = new Date(
                +startDate[2],
                startDate[1] - 1,
                +startDate[0]
            );
            if (date < effectiveDate) {
                navigate('/package-not-available');
            } else if (date >= expiredDate) {
                navigate('/package-expired');
            }
        } else return navigate(ROUTER.USER_NOT_FOUND);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const value = useMemo(
        () => ({
            user,
            username,
            role,
        }),
        [user, username, role]
    );

    return (
        <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
    );
}

// Props
UserProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export const useAuthContext = () => useContext(AuthContext);
